import { gql } from '@apollo/client';
import { AccountFragment } from 'shared/domains/users/utils/fragments';
export const createCompany = gql `
  mutation createCompany(
    $planId: UUID!
    $companyName: String!
    $companyReferrerId: UUID
    $companyMarketCode: String!
    $companyWebDomain: String!
    $userId: String!
    $userName: String!
    $userPhoneNumber: String!
    $userPreferredLocale: String!
  ) {
    updateUser: updateUser2(
      id: $userId
      input: { name: $userName, phoneNumber: $userPhoneNumber, preferredLocale: $userPreferredLocale }
    ) {
      id
      preferredLocale
    }
    account: createCompanyUser2(
      input: {
        role: owner
        userId: $userId
        company: {
          name: $companyName
          referrerId: $companyReferrerId
          marketCode: $companyMarketCode
          webDomain: $companyWebDomain
          planId: $planId
        }
      }
    ) {
      ...AccountFragment @unmask
    }
  }
  ${AccountFragment}
`;
export const createCompanyAccountsQuery = gql `
  query createCompanyAccounts {
    accounts @client {
      ...AccountFragment @unmask
    }
    account @client {
      ...AccountFragment @unmask
    }
  }
  ${AccountFragment}
`;
